//1.ssologin 向vuex中存储人员信息
//2.-----eesbu 系统通过ssologin传过来的人员信息
//3.在组件中使用人员信息 发请求--获取相应的公司权限列表
/**
 * 定义数据
 */
const state = {
  userEesbu: {
    company: 'jiayuan',
    logincode: '',  //code
    pwd: ''    //   pk
  }
}

/**
 * 定义mutations
 */
const mutations = {
  setUserEesbu(state, NewuserEesbu) {
    state.userEesbu = NewuserEesbu;
    // console.log(state.userEesbu);
  },
}

/**
 * 定义getters
 */
const getters = {};

/**
 * 定义actions
 */
const actions = {};

export default {
  name: "eesbucache",
  data: {
    state,
    mutations,
    actions,
    getters
  }
}



// WEBPACK FOOTER //
// ./src/store/cache/eesbucache.js